import React, { useEffect, useState } from 'react';
import { postApi } from '../../../api/call.api';
import { urlApi } from '../../../api/url.api';
import TableComponent from '../../../components/DataTable/TableComponent';
import Pagination from '../../../components/Pagination/Pagination';
import { loadingHide, loadingShow } from '../../../loadingUi/loading.controller';
import { dateIntoYYYY_MM_DD } from '../../../utils/dateTimeConverter';
import { statusCodeToStatusDetails } from '../../../utils/dataInterChange';

const GoogleAdsGroupTab = ({ date, selectedCampaign, setSelectedAdSet, setSelectedTab, selectedAdSet, selectedGoogleAccount }) => {
    const [activePage, setActivePage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [tableData, setTableData] = useState({
        data: [],
        totalCount: 0
    });

    async function getList() {
        loadingShow();
        let postData = {
            googleAdsClientId: selectedGoogleAccount?.googleAdsClientId
        }
        if (date?.startDate) {
            postData.startDate = dateIntoYYYY_MM_DD(date.startDate);
            postData.endDate = dateIntoYYYY_MM_DD(date.endDate);
        }
        let url = `${urlApi.getGoogleAdsGroupList}?page=${activePage}&limit=${perPage}`;
        if (selectedCampaign) {
            url += `&campaignId=${selectedCampaign?._id}`;
        }
        let resp = await postApi(postData, url);
        loadingHide();
        if (resp.responseCode === 200) {
            let localData = selectedAdSet ? resp?.data?.items?.map((item) => {
                if (selectedAdSet?._id === item?._id) {
                    const isSelected = !item.toggleSelected;
                    return {
                        ...item,
                        toggleSelected: isSelected,
                    };
                }
                return {
                    ...item,
                    toggleSelected: false,
                };
            }) : resp?.data?.items
            setTableData({
                data: localData,
                totalCount: resp.data.count
            });
        } else {
            setTableData({
                data: [],
                totalCount: 0
            });
        }
    }

    useEffect(() => {
        getList();
    }, [activePage, date, selectedCampaign, selectedGoogleAccount]);

    function handlePageChange(page) {
        setActivePage(page);
    }

    function handlePerRowsChange(newPerPage, page) {
        setActivePage(page);
        setPerPage(newPerPage)
    }

    const columns = [
        { name: "Sl. No", center: "true", width: '60px', selector: (row) => row?._id, cell: (row, index) => (activePage - 1) * perPage + (index + 1) },
        {
            name: "Ad Group Name", center: "true", selector: (row) => row?.channel_name, grow: 1.4, cell: (row) => (
                <>{row?.adGroupName}</>
            )
        }, {
            name: "Ads Account", center: "true", omit: true, selector: (row) => row?.category, grow: 1.4, cell: (row) => (
                <p className="mb-0">{row?.account_name ?? "--"}</p>
            )
        }, {
            name: "Status", center: "true", selector: (row) => row?.adSetStatus, cell: (row) => (
                <p className={`py-1 mb-0 px-3 rounded-full font-medium text-[10px]`}
                    style={{
                        backgroundColor: statusCodeToStatusDetails(row?.adGroupStatus)?.accentColor,
                        color: statusCodeToStatusDetails(row?.adGroupStatus)?.color
                    }}
                >{statusCodeToStatusDetails(row?.adGroupStatus)?.name}</p>
            )
        }, {
            name: "Amount", center: "true", selector: (row) => row?.spend, grow: 1.4, cell: (row) => (
                "₹" + row?.spend?.toFixed(2) ?? "0"
            )
        }, {
            name: "Conversions", center: "true", selector: (row) => row?.amount, grow: 1.4, cell: (row) => (
                row?.conversions || "--"
            )
        }, {
            name: "Cost/Conversions", center: "true", selector: (row) => row?.amount, grow: 1.4, cell: (row) => (
                row?.cost_per_conversion?.toFixed(2) || "--"
            )
        }, {
            name: "Interactions", center: "true", selector: (row) => row?.interactions, grow: 1.4, cell: (row) => (
                row?.interactions ?? "--"
            )
        }, {
            name: "Interaction Rate", center: "true", selector: (row) => row?.interaction_rate, grow: 1.4, cell: (row) => (
                row?.interaction_rate?.toFixed(2) ?? "--"
            )
        }, {
            name: "Impression", center: "true", selector: (row) => row?.impressions, grow: 0.5, cell: (row) => (
                row?.impressions ?? "--"
            )
        }, {
            name: "Clicks", center: "true", selector: (row) => row?.clicks, grow: 0.5, cell: (row) => (
                row?.clicks
            )
        }, {
            name: "CTR", center: "true", selector: (row) => row?.ctr, grow: 0.5, cell: (row) => (
                row?.ctr?.toFixed(2)
            )
        }
    ];

    const conditionalRowStyles = [
        {
            when: row => row.toggleSelected,
            style: {
                backgroundColor: "var(--green-30) !important",
                userSelect: "none"
            }
        }, {
            when: row => row?._id,
            style: {
                cursor: "pointer"
            }
        }
    ];

    const handleRowClicked = row => {
        const updatedData = tableData.data.map(item => {
            if (row?._id === item?._id) {
                const isSelected = !item.toggleSelected;
                if (isSelected) { setSelectedTab(3) }
                setSelectedAdSet(isSelected ? row : null);
                return {
                    ...item,
                    toggleSelected: isSelected,
                };
            }
            return {
                ...item,
                toggleSelected: false,
            };
        });

        setTableData({
            ...tableData,
            data: updatedData,
        });
    };

    return (
        <>
            <TableComponent
                columns={columns}
                data={tableData.data}
                isHeader={true}
                totalRows={tableData.totalCount}
                isPagination={false}
                paginationPerPage={perPage}
                handlePageChange={(e) => handlePageChange(e)}
                handlePerRowsChange={(newPerPage, page) => handlePerRowsChange(newPerPage, page)}
                onRowClicked={(row) => handleRowClicked(row)}
                conditionalRowStyles={conditionalRowStyles}
            />

            <Pagination itemsPerPage={perPage} totalCount={tableData.totalCount} pageChangeFunction={(pageNum) => handlePageChange(pageNum)} currentPage={activePage} />
        </>
    )
}

export default GoogleAdsGroupTab